import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from 'styled-components';
import { ArrowForwardIcon } from '@rsos/assets/icons';
import { ShareButton } from './AgencyShareChatButton.styles';

/**
 * Sub-component of <AgencyShareChatButton />.
 * Renders the agency share/chat icon button.
 * @param {Boolean} isDisabled - Is the button disabled.
 * @param {Boolean} isSelected - Is the button selected.
 * @param {Function} onClick - Handler when the button is clicked.
 * @param {Function} onHover - Handler when the button is hovered.
 */
const ASCButton = ({ isDisabled, isSelected, onClick, onHover }) => {
  const theme = useContext(ThemeContext);

  return (
    <ShareButton
      dataName="agency-share-chat-button"
      disabled={isDisabled}
      onClick={onClick}
      onPointerEnter={() => onHover(true)}
      onPointerLeave={() => onHover(false)}
      selected={isSelected}
    >
      <ArrowForwardIcon color={theme.colors.secondaryLink} height={14} />
    </ShareButton>
  );
};

ASCButton.propTypes = {
  isDisabled: PropTypes.bool,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func,
  onHover: PropTypes.func,
};

export default ASCButton;
